import { useEffect, useState } from 'react'
import type { RequestStatus } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks'
import { fetchOverdueActivitiesCount } from '@user/features/Activity/store'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization'

export function useFetchOverdueActivitiesCount() {
  const [state, setState] = useState<RequestStatus>('idle')
  const dispatch = useAppDispatch()
  const { userId } = useSelector(selectCurrentUser)
  useEffect(() => {
    let mounted = true

    const execute = async () => {
      setState('loading')
      try {
        const result = await dispatch(fetchOverdueActivitiesCount(userId))

        if (mounted) {
          if (fetchOverdueActivitiesCount.fulfilled.match(result)) {
            setState('success')
          } else {
            setState('error')
          }
        }
      } catch {
        if (mounted) setState('error')
      }
    }

    execute()

    return () => {
      mounted = false
    }
  }, [])

  return state
}
